<div class="wrapper h-100" style="position: relative;">
    <div  *ngIf="isDashBoardPage" id="mainheader" class="pt-1">
        <!-- <app-header [demoIcon]="demoIconFlag"></app-header>
        <app-breadcrumb></app-breadcrumb> -->
        <div class="mb-2">
            <app-categorybar (emitValues)="getFilterValues($event)" [isSalesCode]="true"></app-categorybar>
        </div>
        <div class="wrapper-search-box">
        <!-- <div class="overlay" (click)="dismissSidebar()"></div> -->
        <div class="row d-flex p-0  m-0 justify-content-between justify-content-md-end ">
            <div class="col-2  col-md-2 p-0 d-flex  justify-content-end">
                <div class="all_tokens mb-2 mr-2" (click)="checkAllTokens()" id="all_tokens">
                    <div class="container_chk align-self-center" style="position: absolute;top:8px;">
                        <input type="checkbox" name="" [checked]="searchFilters.operator"
                            [(ngModel)]="searchFilters.operator">
                        <span class="checkmark" disabled></span>
                    </div>
                    <div class="align-self-center pl-4   d-none  d-md-flex">All
                        Tokens</div>
                </div>
            </div>
            
            <div class="col-8 col-md-8   p-0">

                <div class="input-group input-group-content mb-3 p-0">

                    <input
                        type="text"
                        class="form-control form-control-customization"
                        (keyup)="handleKeyUp($event)"
                        (keyup.enter)="searchFiles($event)"
                        [(ngModel)]="searchText"
                        placeholder = "Search Case Studies by Project Name, Region, Contact Person, Project Manager, Location, Related Tags..."
                        aria-label="Recipient's username"
                        aria-describedby="basic-addon2"
                    >
                        <button *ngIf="searchText" type="button" class="btn clear-btn d-flex" (click)="clearSearch()">
                            <span class="material-symbols-outlined">close</span>
                          </button>
                        <div>
                            <button class="btn search_btn searchmsicon d-flex align-items-center justify-content-center" id="text-search" type="button" (click)="searchFiles($event)">
                                <span class="material-symbols-outlined">search</span>
                            </button>
                        </div>
                </div>
            </div>
        </div>
            <div class="col-2 col-md-2 p-0  my-1 text-center">
                <div class="d-inline-flex" id="sidebarCollapse1"></div>
            </div>
        </div>
        
       
    </div>
    <!-- <div id="backset" style="height:70px;"></div> -->
    

    <app-searchresults #searchResults projectsView="{{searchFilters.displayType}}" (demo)="hideDemo($event)">
    </app-searchresults>